var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3703d7124c9b2b53030be2be06b27500.js').default;export default
        Object.assign({}, scope_0 )
    